import React ,{ useState } from "react";

import Hero from "../components/home/Hero";
import Services from "../components/home/Services";
import Segments from "../components/home/Segments";
import Portfolio from "../components/home/Portfolio";
import WhyChoose from "../components/home/WhyChoose";
import Process from "../components/home/Process";
import BeforeAfter from "../components/home/BeforeAfter";
import Team from "../components/home/Team";
import Testimonials from "../components/home/Testimonials";
import VideoTestimonials from "../components/home/VideoTestimonials";
import Contact from "../components/home/Contact";
import Footer from "../components/home/Footer";
import BudgetCalculator from "../components/home/BudgetCalculator";
import LiveChat from "../components/home/LiveChat";
import QuoteModal from "../components/ui/QuoteModal";

export default function Home() {
  const [isQuoteOpen, setIsQuoteOpen] = useState(false);
  return (
    <div className="bg-[#FDFBF7] min-h-screen">
      <Hero onGetQuote={() => setIsQuoteOpen(true)} />
      <Services />
      <Segments />
      <Portfolio />
      <WhyChoose />
      <Process />
      <BeforeAfter />
      <Team />
      <BudgetCalculator />
      <Testimonials />
      <VideoTestimonials />
      <Contact />
      <Footer />
      <LiveChat />
      <QuoteModal
        open={isQuoteOpen}
        onClose={() => setIsQuoteOpen(false)}
      />
    </div>
  );
}
